import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getIndustryById } from '../data/industryQuotes';
import { analytics } from '../services/analytics';
import { quoteService } from '../services/quoteService';

// Inline premium icons to replace emojis in demo quotes
const LandscapingIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 20v-8" />
    <path d="M12 12c-3 0-5-2-6-5 3 0 5 2 6 5" />
    <path d="M12 10c2-3 5-4 8-4-1 3-3 5-8 4" />
  </svg>
);

const PestControlIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="6" r="1" />
    <path d="M8 11a4 4 0 0 1 8 0v3a4 4 0 0 1-8 0v-3z" />
    <path d="M12 7v10" />
    <path d="M10.5 4.5 9.5 3.5" />
    <path d="M13.5 4.5 14.5 3.5" />
    <path d="M8 12H5" />
    <path d="M8 15H5" />
    <path d="M16 12h3" />
    <path d="M16 15h3" />
  </svg>
);

const WebDesignIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 6 4 12 9 18" />
    <polyline points="15 6 20 12 15 18" />
    <path d="M13 6l-2 12" />
  </svg>
);

const WeddingPhotographyIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="7" width="18" height="14" rx="2" />
    <path d="M9 7l1.5-2h3L15 7" />
    <circle cx="12" cy="14" r="3" />
  </svg>
);

const PaintingIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="5" width="10" height="6" rx="2" />
    <path d="M13 8h3" />
    <path d="M16 8v8" />
    <path d="M16 16c0 2 0 3-2 3H13" />
  </svg>
);

const HvacIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 8h10c2 0 3-1 3-3" />
    <path d="M3 12h14" />
    <path d="M3 16h10c2 0 3 1 3 3" />
  </svg>
);

const RoofingIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 12l8-6 8 6" />
    <path d="M16 6v3" />
    <path d="M5 12v6h14v-6" />
    <path d="M8 16h8" />
  </svg>
);

const PlumbingIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 8v4a4 4 0 0 0 8 0V8h4" />
    <path d="M6 8h6" />
    <path d="M18 6v2" />
    <path d="M18 10c1 1.2 1.5 2 1.5 3a2.5 2.5 0 1 1-5 0c0-1 .5-1.8 1.5-3" />
  </svg>
);

const ElectricalIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);

const SolarIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="10" width="12" height="8" rx="2" />
    <path d="M3 13h12M3 15h12M7 10v8M11 10v8" />
    <circle cx="19" cy="7" r="2" />
    <path d="M19 3v2M19 9v2M15 7h2M21 7h2" />
  </svg>
);

const PoolIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="6" width="16" height="10" rx="4" />
    <path d="M8 10h3M8 12h3" />
    <path d="M6 16c1 0 2-.4 3-.8s2-.8 3-.8 2 .4 3 .8 2 .8 3 .8 2-.4 3-.8 2-.8 3-.8" />
  </svg>
);

const InteriorDesignIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 13a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3" />
    <rect x="6" y="13" width="12" height="5" rx="2" />
    <path d="M6 18v2M18 18v2" />
  </svg>
);

const CateringIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 17h18" />
    <path d="M5 17a7 7 0 0 1 14 0" />
    <path d="M12 6v2" />
  </svg>
);

const AutoDetailingIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 13h16l-1.2-3.2a2 2 0 0 0-1.8-1.2H7a2 2 0 0 0-1.8 1.2L4 13Z" />
    <circle cx="7" cy="16" r="1.5" />
    <circle cx="17" cy="16" r="1.5" />
    <path d="M16 5l.6 1.2L18 6.8l-1.4.6L16 9l-.6-1.6L14 6.8l1.4-.6L16 5z" />
  </svg>
);

const TreeServiceIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 20v-4" />
    <path d="M12 4l-5 6h10l-5-6z" />
    <path d="M12 8l-4 5h8l-4-5z" />
  </svg>
);
// Demo interactive products for different industries
const getDemoInteractiveProducts = (industryId) => {
  const productsByIndustry = {
    'painter': [
      {
        id: 'paint-quality-upgrade',
        name: 'Premium Paint Upgrade',
        description: 'Upgrade to premium paint with 20-year warranty',
        base_price: 150,
        unit_name: 'room',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 2, price_per_unit: 150 },
          { min_quantity: 3, max_quantity: 5, price_per_unit: 135 },
          { min_quantity: 6, max_quantity: null, price_per_unit: 120 }
        ]
      },
      {
        id: 'color-consultation',
        name: 'Professional Color Consultation',
        description: 'Expert color matching and design consultation',
        base_price: 75,
        unit_name: 'hour',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 1, price_per_unit: 75 },
          { min_quantity: 2, max_quantity: 3, price_per_unit: 70 },
          { min_quantity: 4, max_quantity: null, price_per_unit: 65 }
        ]
      }
    ],
    'hvac': [
      {
        id: 'smart-thermostat-upgrade',
        name: 'Smart Thermostat Installation',
        description: 'Nest or Ecobee smart thermostat with professional installation',
        base_price: 300,
        unit_name: 'unit',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 1, price_per_unit: 300 },
          { min_quantity: 2, max_quantity: 3, price_per_unit: 275 },
          { min_quantity: 4, max_quantity: null, price_per_unit: 250 }
        ]
      },
      {
        id: 'air-purification',
        name: 'Whole-Home Air Purification',
        description: 'UV light air purification system installation',
        base_price: 450,
        unit_name: 'system',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 1, price_per_unit: 450 }
        ]
      }
    ],
    'pest-control': [
      {
        id: 'quarterly-service',
        name: 'Quarterly Service Upgrade',
        description: 'Upgrade from bi-annual to quarterly treatments',
        base_price: 50,
        unit_name: 'treatment',
        pricing_tiers: [
          { min_quantity: 4, max_quantity: 4, price_per_unit: 50 },
          { min_quantity: 8, max_quantity: null, price_per_unit: 45 }
        ]
      }
    ],
    'web-design': [
      {
        id: 'seo-package',
        name: 'SEO Optimization Package',
        description: 'Complete SEO setup and 3 months of optimization',
        base_price: 500,
        unit_name: 'package',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 1, price_per_unit: 500 }
        ]
      },
      {
        id: 'additional-pages',
        name: 'Additional Pages',
        description: 'Extra pages beyond the included pages',
        base_price: 150,
        unit_name: 'page',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 3, price_per_unit: 150 },
          { min_quantity: 4, max_quantity: 10, price_per_unit: 125 },
          { min_quantity: 11, max_quantity: null, price_per_unit: 100 }
        ]
      }
    ],
    'wedding-photography': [
      {
        id: 'additional-hours',
        name: 'Additional Coverage Hours',
        description: 'Extra hours of wedding day coverage',
        base_price: 200,
        unit_name: 'hour',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 2, price_per_unit: 200 },
          { min_quantity: 3, max_quantity: null, price_per_unit: 175 }
        ]
      },
      {
        id: 'drone-photography',
        name: 'Drone Photography Add-on',
        description: 'Aerial drone photos and video clips',
        base_price: 300,
        unit_name: 'session',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 1, price_per_unit: 300 }
        ]
      }
    ],
    'landscaping': [
      {
        id: 'seasonal-maintenance',
        name: 'Seasonal Maintenance Plan',
        description: 'Year-round maintenance and care package',
        base_price: 200,
        unit_name: 'month',
        pricing_tiers: [
          { min_quantity: 6, max_quantity: 11, price_per_unit: 200 },
          { min_quantity: 12, max_quantity: null, price_per_unit: 175 }
        ]
      },
      {
        id: 'irrigation-upgrade',
        name: 'Smart Irrigation System',
        description: 'Weather-based smart irrigation controls',
        base_price: 800,
        unit_name: 'zone',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 3, price_per_unit: 800 },
          { min_quantity: 4, max_quantity: null, price_per_unit: 750 }
        ]
      }
    ],
    'roofing': [
      {
        id: 'gutter-replacement',
        name: 'Complete Gutter System Replacement',
        description: 'Replace existing gutters with premium seamless gutters',
        base_price: 1200,
        unit_name: 'linear foot',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 100, price_per_unit: 12 },
          { min_quantity: 101, max_quantity: 200, price_per_unit: 11 },
          { min_quantity: 201, max_quantity: null, price_per_unit: 10 }
        ]
      },
      {
        id: 'skylight-installation',
        name: 'Skylight Installation',
        description: 'Add natural light with professional skylight installation',
        base_price: 800,
        unit_name: 'skylight',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 2, price_per_unit: 800 },
          { min_quantity: 3, max_quantity: null, price_per_unit: 750 }
        ]
      }
    ],
    'plumbing': [
      {
        id: 'water-heater-upgrade',
        name: 'Tankless Water Heater Upgrade',
        description: 'Upgrade to high-efficiency tankless water heater',
        base_price: 1500,
        unit_name: 'unit',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 1, price_per_unit: 1500 }
        ]
      },
      {
        id: 'drain-cleaning',
        name: 'Complete Drain System Cleaning',
        description: 'Professional hydro-jetting and drain inspection',
        base_price: 200,
        unit_name: 'drain',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 3, price_per_unit: 200 },
          { min_quantity: 4, max_quantity: null, price_per_unit: 175 }
        ]
      }
    ],
    'electrical': [
      {
        id: 'outlet-upgrades',
        name: 'GFCI Outlet Installation',
        description: 'Upgrade existing outlets to GFCI for safety',
        base_price: 75,
        unit_name: 'outlet',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 5, price_per_unit: 75 },
          { min_quantity: 6, max_quantity: 15, price_per_unit: 65 },
          { min_quantity: 16, max_quantity: null, price_per_unit: 60 }
        ]
      },
      {
        id: 'ev-charging-prep',
        name: 'EV Charging Station Preparation',
        description: '240V outlet and wiring for electric vehicle charging',
        base_price: 800,
        unit_name: 'installation',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 1, price_per_unit: 800 }
        ]
      }
    ],
    'solar': [
      {
        id: 'battery-backup',
        name: 'Battery Storage System',
        description: 'Add battery backup for energy independence',
        base_price: 8000,
        unit_name: 'system',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 1, price_per_unit: 8000 }
        ]
      },
      {
        id: 'monitoring-system',
        name: 'Advanced Monitoring Package',
        description: 'Real-time solar production and usage monitoring',
        base_price: 500,
        unit_name: 'system',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 1, price_per_unit: 500 }
        ]
      }
    ],
    'pool-construction': [
      {
        id: 'pool-heater',
        name: 'Pool Heating System',
        description: 'Extend swimming season with efficient pool heater',
        base_price: 3000,
        unit_name: 'system',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 1, price_per_unit: 3000 }
        ]
      },
      {
        id: 'water-features',
        name: 'Water Feature Add-ons',
        description: 'Waterfalls, fountains, or spa jets',
        base_price: 1500,
        unit_name: 'feature',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 2, price_per_unit: 1500 },
          { min_quantity: 3, max_quantity: null, price_per_unit: 1300 }
        ]
      }
    ],
    'interior-design': [
      {
        id: 'custom-furniture',
        name: 'Custom Furniture Pieces',
        description: 'Bespoke furniture designed for your space',
        base_price: 2000,
        unit_name: 'piece',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 3, price_per_unit: 2000 },
          { min_quantity: 4, max_quantity: null, price_per_unit: 1800 }
        ]
      },
      {
        id: 'lighting-design',
        name: 'Custom Lighting Package',
        description: 'Designer lighting fixtures and installation',
        base_price: 500,
        unit_name: 'room',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 3, price_per_unit: 500 },
          { min_quantity: 4, max_quantity: null, price_per_unit: 450 }
        ]
      }
    ],
    'catering': [
      {
        id: 'premium-bar',
        name: 'Premium Bar Service',
        description: 'Top-shelf liquor and craft cocktail service',
        base_price: 15,
        unit_name: 'guest',
        pricing_tiers: [
          { min_quantity: 25, max_quantity: 50, price_per_unit: 15 },
          { min_quantity: 51, max_quantity: 100, price_per_unit: 13 },
          { min_quantity: 101, max_quantity: null, price_per_unit: 12 }
        ]
      },
      {
        id: 'dessert-station',
        name: 'Gourmet Dessert Station',
        description: 'Interactive dessert bar with chef attendant',
        base_price: 12,
        unit_name: 'guest',
        pricing_tiers: [
          { min_quantity: 25, max_quantity: 50, price_per_unit: 12 },
          { min_quantity: 51, max_quantity: null, price_per_unit: 10 }
        ]
      }
    ],
    'auto-detailing': [
      {
        id: 'paint-protection',
        name: 'Paint Protection Film',
        description: 'Clear protective film for high-impact areas',
        base_price: 800,
        unit_name: 'vehicle',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 1, price_per_unit: 800 }
        ]
      },
      {
        id: 'interior-protection',
        name: 'Interior Fabric Protection',
        description: 'Professional fabric and leather protection treatment',
        base_price: 150,
        unit_name: 'vehicle',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 2, price_per_unit: 150 },
          { min_quantity: 3, max_quantity: null, price_per_unit: 130 }
        ]
      }
    ],
    'tree-service': [
      {
        id: 'stump-grinding',
        name: 'Stump Grinding Service',
        description: 'Complete stump removal and grinding',
        base_price: 150,
        unit_name: 'stump',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 3, price_per_unit: 150 },
          { min_quantity: 4, max_quantity: null, price_per_unit: 125 }
        ]
      },
      {
        id: 'plant-replacement',
        name: 'Tree Replacement Planting',
        description: 'Plant new trees to replace removed ones',
        base_price: 300,
        unit_name: 'tree',
        pricing_tiers: [
          { min_quantity: 1, max_quantity: 5, price_per_unit: 300 },
          { min_quantity: 6, max_quantity: null, price_per_unit: 275 }
        ]
      }
    ]
  };
  
  return productsByIndustry[industryId] || [];
};

const DemoQuote = () => {
  const { industryId } = useParams();
  const [selectedTier, setSelectedTier] = useState(''); // match production: no default
  const [industry, setIndustry] = useState(null);
  const [signatureName, setSignatureName] = useState('');
  const [clientEmail, setClientEmail] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [accepted, setAccepted] = useState(false);
  
  // Interactive products state
  const [interactiveProducts, setInteractiveProducts] = useState([]);
  const [productQuantities, setProductQuantities] = useState({});
  const [interactiveTotal, setInteractiveTotal] = useState(0);

  useEffect(() => {
    if (!industryId) return;
    
    const industryData = getIndustryById(industryId);
    setIndustry(industryData); // Always set industry, even if null
    
    if (industryData) {
      const demoProducts = getDemoInteractiveProducts(industryId);
      setInteractiveProducts(demoProducts);
      
      // Initialize quantities to 0
      const initialQuantities = {};
      demoProducts.forEach(product => {
        initialQuantities[product.id] = 0;
      });
      setProductQuantities(initialQuantities);
      
      // Track demo quote view
      analytics.track('Demo Quote Viewed', { 
        industry: industryData.name,
        industryId: industryId 
      });
    }
  }, [industryId]);

  const handleTierSelect = (tier) => {
    if (accepted) return;
    setSelectedTier(tier);
    analytics.track('Demo Quote Tier Selected', { 
      industry: industry.name,
      tier: tier,
      price: industry.tiers[tier].price
    });
  };

  const updateProductQuantity = (productId, quantity) => {
    const newQuantities = { ...productQuantities, [productId]: Math.max(0, quantity) };
    setProductQuantities(newQuantities);
    
    // Calculate total using production helper
    const total = Object.entries(newQuantities).reduce((sum, [id, qty]) => {
      const product = interactiveProducts.find(p => p.id === id);
      if (product && qty > 0) {
        const calc = quoteService.calculateOptimalPrice(product.pricing_tiers, qty, product.base_price);
        return sum + (calc.total_price || calc.price_per_unit * qty);
      }
      return sum;
    }, 0);
    
    setInteractiveTotal(total);
  };

  // pricing uses quoteService.calculateOptimalPrice for parity with production

  const handleAcceptQuote = (e) => {
    e.preventDefault();
    
    if (!selectedTier) {
      toast.error('Please select a package');
      return;
    }
    
    if (!signatureName.trim()) {
      toast.error('Please enter your name to sign');
      return;
    }
    
    if (!clientEmail.trim()) {
      toast.error('Please enter your email address');
      return;
    }
    
    if (!agreed) {
      toast.error('Please agree to the terms and conditions');
      return;
    }
    
    setAccepted(true);
    toast.success('Demo quote accepted! In a real scenario, you would receive confirmation via email.');
    
    analytics.track('Demo Quote Accept Clicked', { 
      industry: industry.name,
      selectedTier: selectedTier,
      price: industry.tiers[selectedTier].price + interactiveTotal
    });
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(price || 0);
  };

  const demoUniqueId = `DEMO-${industryId.toUpperCase()}`;

  // Simple, safe title update - only when industry is first loaded
  useEffect(() => {
    if (industry && industry.name) {
      document.title = `${industry.name} Demo Quote | QuoteTier`;
    }
    return () => {
      document.title = "QuoteTier — Interactive Quote Builder";
    };
  }, [industry?.name]); // Only depend on the name string, not the full object

  // Handle loading state - this MUST come after all hooks
  if (!industry) {
    return (
      <div className="min-h-screen bg-background text-foreground flex items-center justify-center">
        <div className="text-center max-w-md mx-auto px-4">
          <h1 className="text-3xl font-bold text-foreground mb-4 font-instrument">Quote Not Found</h1>
          <p className="text-muted-foreground font-jetbrains mb-6">
            This demo quote does not exist. Please return to the homepage to try again.
          </p>
          <Link to="/" className="inline-block px-6 py-3 bg-black text-white rounded-lg font-instrument hover:bg-gray-800">
            Return to Homepage
          </Link>
        </div>
      </div>
    );
  }

  // Create demo quote object that matches production structure - AFTER null check
  const demoQuote = {
    clientName: `${industry.name.split(' ')[0]} Client Demo`,
    owner: {
      businessName: `${industry.name} Pro Services`,
      name: 'Demo Business Owner',
      avatarUrl: null
    },
    tiers: industry.tiers,
    status: accepted ? 'accepted' : 'pending',
    interactiveEnabled: true
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Instrument+Serif&family=JetBrains+Mono:wght@400;500&display=swap');
        .font-instrument { font-family: 'Instrument Serif', serif; }
        .font-jetbrains { font-family: 'JetBrains Mono', monospace; }
      `}</style>

      <div className="max-w-4xl mx-auto px-4 md:px-6 py-6 md:py-8">
        
        {/* Demo notice removed for pixel parity */}

        {/* PRODUCTION-STYLE HEADER */}
        <div className="border border-black rounded-lg mb-8 bg-white shadow-lg overflow-hidden">
          <div className="bg-black px-6 py-6 text-white">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="h-12 w-12 rounded-lg border border-white/20 bg-white/10 flex items-center justify-center text-white">
                  {industry.id === 'landscaping' ? (
                    <LandscapingIcon className="h-6 w-6" />
                  ) : industry.id === 'pest-control' ? (
                    <PestControlIcon className="h-6 w-6" />
                  ) : industry.id === 'web-design' ? (
                    <WebDesignIcon className="h-6 w-6" />
                  ) : industry.id === 'wedding-photography' ? (
                    <WeddingPhotographyIcon className="h-6 w-6" />
                  ) : industry.id === 'painter' ? (
                    <PaintingIcon className="h-6 w-6" />
                  ) : industry.id === 'hvac' ? (
                    <HvacIcon className="h-6 w-6" />
                  ) : industry.id === 'roofing' ? (
                    <RoofingIcon className="h-6 w-6" />
                  ) : industry.id === 'plumbing' ? (
                    <PlumbingIcon className="h-6 w-6" />
                  ) : industry.id === 'electrical' ? (
                    <ElectricalIcon className="h-6 w-6" />
                  ) : industry.id === 'solar' ? (
                    <SolarIcon className="h-6 w-6" />
                  ) : industry.id === 'pool-construction' ? (
                    <PoolIcon className="h-6 w-6" />
                  ) : industry.id === 'interior-design' ? (
                    <InteriorDesignIcon className="h-6 w-6" />
                  ) : industry.id === 'catering' ? (
                    <CateringIcon className="h-6 w-6" />
                  ) : industry.id === 'auto-detailing' ? (
                    <AutoDetailingIcon className="h-6 w-6" />
                  ) : industry.id === 'tree-service' ? (
                    <TreeServiceIcon className="h-6 w-6" />
                  ) : null}
                </div>
                <div>
                  <h1 className="text-xl font-bold text-white font-instrument">{demoQuote.owner.businessName}</h1>
                  <p className="text-gray-300 font-jetbrains">Quote for {demoQuote.clientName}</p>
                </div>
              </div>
              <div className="text-right">
                <div className="text-gray-300 text-sm font-jetbrains">Quote ID</div>
                <div className="text-white font-instrument font-bold">#{demoUniqueId}</div>
              </div>
            </div>
          </div>

          {/* ACCEPTED STATUS */}
          {accepted && (
            <div className="px-6 py-4 bg-green-50 border-b border-green-200">
              <div className="flex items-center">
                <div className="h-8 w-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                  <svg className="h-4 w-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <div className="font-bold text-green-900 font-instrument">Quote Accepted!</div>
                  <div className="text-green-700 font-jetbrains text-sm">
                    {demoQuote.tiers[selectedTier]?.title} - {formatPrice((demoQuote.tiers[selectedTier]?.price || 0) + interactiveTotal)}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* PRODUCTION-STYLE PACKAGES */}
        <div className="border border-black rounded-lg mb-8 bg-white shadow-lg overflow-hidden">
          <div className="bg-black px-6 py-4">
            <h2 className="text-xl font-bold text-white font-instrument">Choose Your Package</h2>
            <p className="text-gray-300 font-jetbrains">Select the option that best fits your needs</p>
          </div>
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
              {demoQuote.tiers && Object.entries(demoQuote.tiers).map(([tierName, tier], index) => {
                const isPopular = tierName === 'better';
                const isSelected = selectedTier === tierName;
                return (
                  <div
                    key={tierName}
                    onClick={() => handleTierSelect(tierName)}
                    className={`relative border-2 rounded-lg cursor-pointer transition-all flex flex-col h-full min-h-[400px] md:min-h-[300px] p-4 md:p-6 ${
                      isSelected 
                        ? 'border-black bg-gray-50 shadow-lg' 
                        : 'border-gray-200 hover:border-black hover:shadow-md bg-white'
                    } ${accepted ? 'cursor-not-allowed opacity-75' : ''}`}
                  >
                    {isPopular && (
                      <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 z-10">
                        <div className="bg-black text-white px-3 py-1 rounded-full text-xs font-bold font-instrument">
                          Most Popular
                        </div>
                      </div>
                    )}
                    
                    {/* CARD HEADER - Fixed height */}
                    <div className="text-center p-4 pb-2">
                      <h3 className="text-lg font-bold text-gray-900 mb-2 font-instrument capitalize">{tierName}</h3>
                      <div className="text-2xl font-bold text-gray-900 mb-2 font-instrument">{formatPrice(tier.price)}</div>
                      <h4 className="text-md font-semibold text-gray-700 mb-4 font-jetbrains">{tier.title}</h4>
                    </div>
                    
                    {/* CARD CONTENT - Flexible height */}
                    <div className="flex-1 px-4 pb-4">
                      <div className="text-left space-y-2 h-full flex flex-col">
                        {/* SHOW DESCRIPTION FIRST (if it exists) */}
                        {tier.description && (
                          <div className="text-sm text-gray-600 font-jetbrains mb-3 p-3 bg-gray-50 rounded-lg border">
                            {tier.description}
                          </div>
                        )}
                        
                        {/* THEN SHOW BULLET POINTS (if they exist) - Flexible space */}
                        <div className="flex-1">
                          {(tier.bulletPoints && tier.bulletPoints.length > 0) && (
                            <div className="space-y-2">
                              {tier.bulletPoints.map((feature, index) => (
                                <div key={index} className="text-sm text-gray-600 flex items-start font-jetbrains">
                                  <div className="w-4 h-4 bg-black rounded-full flex items-center justify-center mr-2 mt-0.5 flex-shrink-0">
                                    <svg className="w-2 h-2 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                    </svg>
                                  </div>
                                  <span className="flex-1">{feature.trim()}</span>
                                </div>
                              ))}
                            </div>
                          )}
                          
                          {/* FALLBACK: Show message if neither exists */}
                          {!tier.description && (!tier.bulletPoints || tier.bulletPoints.length === 0) && (
                            <div className="text-sm text-gray-500 font-jetbrains italic text-center py-4">
                              No details available for this package
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    
                    {/* CARD FOOTER - Always at bottom */}
                    <div className="p-4 pt-0 mt-auto">
                      {isSelected ? (
                        <div className="bg-black text-white py-3 px-4 rounded-lg font-bold flex items-center justify-center font-instrument w-full">
                          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                          Selected
                        </div>
                      ) : (
                        <div className="border-2 border-gray-300 text-gray-700 py-3 px-4 rounded-lg font-bold text-center font-instrument w-full hover:border-black hover:text-black transition-colors">
                          Select This Package
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* INTERACTIVE PRODUCTS SECTION */}
        {interactiveProducts.length > 0 && (
          <div className="border border-black rounded-lg mb-8 bg-white shadow-lg overflow-hidden">
            <div className="bg-black px-6 py-4">
              <h2 className="text-xl font-bold text-white font-instrument">Optional Add-Ons</h2>
              <p className="text-gray-300 font-jetbrains">Enhance your service with these optional upgrades</p>
            </div>
            <div className="p-6">
              <div className="space-y-4">
                {interactiveProducts.map((product) => {
                  const quantity = productQuantities[product.id] || 0;
                  const priceCalc = quoteService.calculateOptimalPrice(product.pricing_tiers, quantity, product.base_price);
                  const pricePerUnit = priceCalc.price_per_unit;
                  const totalPrice = priceCalc.total_price || (pricePerUnit * quantity);
                  const bulkSavings = priceCalc.savings || 0;
                  const hasDiscount = bulkSavings > 0;
                  
                  return (
                    <div key={product.id} className="border border-gray-200 rounded-lg p-4">
                      <div className="flex flex-col md:flex-row md:items-center justify-between space-y-3 md:space-y-0">
                        <div className="flex-1">
                          <h3 className="font-instrument text-lg font-semibold text-gray-900">{product.name}</h3>
                          <p className="font-jetbrains text-sm text-gray-600 mt-1">{product.description}</p>
                          <div className="font-jetbrains text-sm text-gray-500 mt-2">
                            Base price: {formatPrice(product.base_price)} per {product.unit_name}
                          </div>
                        </div>
                        
                        <div className="flex items-center space-x-4">
                          <div className="flex items-center space-x-2">
                            <button
                              onClick={() => updateProductQuantity(product.id, quantity - 1)}
                              className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-50"
                              disabled={quantity <= 0}
                            >
                              -
                            </button>
                            <span className="w-12 text-center font-jetbrains font-bold">{quantity}</span>
                            <button
                              onClick={() => updateProductQuantity(product.id, quantity + 1)}
                              className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-50"
                            >
                              +
                            </button>
                          </div>
                          
                          <div className="text-right min-w-[120px]">
                            {quantity > 0 ? (
                              <div>
                                <div className="font-instrument font-bold text-lg">{formatPrice(totalPrice)}</div>
                                <div className="font-jetbrains text-xs text-gray-500">{formatPrice(pricePerUnit)} each {hasDiscount && (<span className="text-green-600 font-bold ml-1">(save {formatPrice(bulkSavings)})</span>)}</div>
                              </div>
                            ) : (
                              <div className="font-jetbrains text-gray-400 text-sm">Not selected</div>
                            )}
                          </div>
                        </div>
                      </div>
                      {quantity > 0 && (
                        <div className="mt-3 bg-gray-50 rounded-lg p-3 text-center border">
                          <div className="text-sm text-gray-600 font-jetbrains">Subtotal</div>
                          <div className="text-lg font-bold text-gray-900 font-instrument">{formatPrice(totalPrice)}</div>
                          {hasDiscount && (
                            <div className="text-xs text-green-600 font-bold font-jetbrains">Total savings: {formatPrice(bulkSavings)}</div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {/* QUOTE SUMMARY - match production */}
        {selectedTier && (
          <div className="border border-black rounded-lg mb-8 bg-white shadow-lg overflow-hidden">
            <div className="bg-black px-6 py-4">
              <h2 className="text-xl font-bold text-white font-instrument">Quote Summary</h2>
              <p className="text-gray-300 font-jetbrains">Review your selection</p>
            </div>
            <div className="p-6">
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="font-jetbrains text-gray-600">Selected Package:</span>
                  <span className="font-instrument font-semibold">{demoQuote.tiers[selectedTier]?.title}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="font-jetbrains text-gray-600">Package Price:</span>
                  <span className="font-instrument font-semibold">{formatPrice(demoQuote.tiers[selectedTier]?.price)}</span>
                </div>
                {interactiveTotal > 0 && (
                  <div className="flex justify-between items-center">
                    <span className="font-jetbrains text-gray-600">Add-ons Total:</span>
                    <span className="font-instrument font-semibold">{formatPrice(interactiveTotal)}</span>
                  </div>
                )}
                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200 mt-3">
                  <div className="flex justify-between items-center">
                    <div>
                      <div className="text-xl font-bold text-gray-900 font-instrument">Total Investment</div>
                      <div className="text-sm text-gray-600 font-jetbrains">Complete project cost</div>
                    </div>
                    <div className="text-2xl font-bold text-gray-900 font-instrument">{formatPrice((demoQuote.tiers[selectedTier]?.price || 0) + interactiveTotal)}</div>
                  </div>
                  {interactiveTotal > 0 && (
                    <div className="mt-3 text-sm text-gray-600 font-jetbrains">
                      <div className="flex justify-between">
                        <span>Base: {formatPrice(demoQuote.tiers[selectedTier]?.price || 0)}</span>
                        <span>Add-ons: {formatPrice(interactiveTotal)}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* SIGNATURE SECTION - match production */}
        {selectedTier && !accepted && (
          <div className="border border-black rounded-lg mb-8 bg-white shadow-lg overflow-hidden">
            <div className="bg-black px-6 py-4">
              <h2 className="text-xl font-bold text-white font-instrument">Accept Quote</h2>
              <p className="text-gray-300 font-jetbrains">Complete your order below</p>
            </div>
            <div className="p-6">
              <form onSubmit={handleAcceptQuote} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="clientEmail" className="block text-sm md:text-base font-bold text-gray-900 mb-2 font-instrument">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      id="clientEmail"
                      name="clientEmail"
                      value={clientEmail}
                      onChange={(e) => setClientEmail(e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-black font-jetbrains text-base min-h-[48px]"
                      placeholder="Enter your email address"
                      autoComplete="email"
                      required
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="signatureName" className="block text-sm md:text-base font-bold text-gray-900 mb-2 font-instrument">
                      Electronic Signature *
                    </label>
                    <input
                      type="text"
                      id="signatureName"
                      value={signatureName}
                      onChange={(e) => setSignatureName(e.target.value)}
                      className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-black font-jetbrains text-base min-h-[48px]"
                      placeholder="Type your full name"
                      required
                    />
                    <p className="text-xs text-gray-500 mt-1 font-jetbrains">Legally binding under ESIGN Act & UETA</p>
                  </div>
                </div>
                
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                  <div className="flex items-start">
                    <input
                      id="agreement"
                      type="checkbox"
                      checked={agreed}
                      onChange={(e) => setAgreed(e.target.checked)}
                      className="h-4 w-4 text-black focus:ring-black border-2 border-gray-300 rounded mt-1"
                      required
                    />
                    <div className="ml-3">
                      <label htmlFor="agreement" className="text-sm font-bold text-gray-900 font-instrument">
                        I accept the terms of this quote
                      </label>
                      <p className="text-gray-600 mt-1 font-jetbrains text-sm">
                        By checking this box, I confirm that I have reviewed this quote and authorize {demoQuote.owner.businessName} to proceed with the work as described.
                      </p>
                    </div>
                  </div>
                </div>
                
                <button
                  type="submit"
                  className="w-full bg-black text-white py-4 px-6 rounded-lg text-base md:text-lg font-bold hover:bg-gray-800 focus:outline-none focus:ring-4 focus:ring-gray-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all font-instrument min-h-[56px]"
                >
                  Accept Quote - {formatPrice((demoQuote.tiers[selectedTier]?.price || 0) + interactiveTotal)}
                </button>
              </form>
            </div>
          </div>
        )}

        {/* DEMO CTA */}
        <div className="text-center">
          <div className="bg-gray-900 text-white rounded-lg p-8 mb-6">
            <h3 className="font-instrument text-2xl mb-4">Ready to Create Quotes Like This?</h3>
            <p className="font-jetbrains text-gray-300 mb-6">
              This demo shows exactly how your customers will experience your quotes. Start creating professional, interactive quotes for your business today.
            </p>
            <Link to="/signup" onClick={() => analytics.track('Demo CTA Clicked', { industry: industry.name })}>
              <button className="font-instrument text-lg px-8 py-3 bg-white text-gray-900 hover:bg-gray-100 rounded-lg font-bold transition-colors">
                Start Free
              </button>
            </Link>
          </div>
          
          <p className="font-jetbrains text-sm text-gray-500">
            Want to see more examples? 
            <Link to="/" className="text-blue-600 hover:text-blue-700 ml-1">
              ← Back to all industry examples
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default DemoQuote;
